

import { Injectable, inject } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, debounceTime, tap, withLatestFrom} from 'rxjs/operators';
import { ThemeManagerService } from '@aston/themes';
import { Store } from '@ngrx/store';

import { AppStoreActions, AppStoreSelectors } from '../../app-store';

import * as featureActions from './../actions';

@Injectable({providedIn: 'root'})
export class UserPrefsStoreThemeEffects {
	private actions$ = inject(Actions);
	private store = inject(Store);
	private themeManager = inject(ThemeManagerService);


	loadTheme$ = createEffect(() => this.actions$.pipe(
		ofType(AppStoreActions.Login, AppStoreActions.LoadUserSuccess),
		withLatestFrom(this.store.select(AppStoreSelectors.selectUser)),
		tap(([_, userData]) => {
			if (userData) try {
				userData.userPrefs = JSON.parse(localStorage.getItem(userData.id + '-user-prefs'))
			} catch {
				console.warn('failed to load user preferences')
			}
		}),
		tap(([_, userData]) => this.themeManager.useTheme(userData?.userPrefs?.themeId || 'default')),
		map(_ => AppStoreActions.Noop())
	));

	updateTheme$ = createEffect(() => this.actions$.pipe(
		ofType(featureActions.UpdatePreferredTheme),
		tap(({theme}) => this.themeManager.useTheme(theme.id)),
		withLatestFrom(this.store.select(AppStoreSelectors.selectUser)),
		debounceTime(500),
		tap(([{theme}, userData]) => {
			localStorage.setItem(userData.id + '-user-prefs', JSON.stringify({ themeId: theme.id }))
		}),
		map(_ => AppStoreActions.Noop())
	));
}
